// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"d6612e55","453":"07de2aa6","457":"f0177a31","484":"bf7ec942","551":"8c187185","707":"54fa16cc"}[chunkId] + ".chunk.js";
};